import instance from '../axios';

export const createRefunds = async (data) => {
  const response = await instance.post('refunds/create', data);
  return response.data;
};

export const updateRefunds = async (data) => {
  const response = await instance.post('refunds/update', data);
  return response.data;
};

export const deleteRefunds = async (data) => {
  const response = await instance.post('refunds/delete', data);
  return response.data;
};

export const getAllRefunds = async () => {
  const response = await instance.get('refunds/get-all');
  return response.data;
};

export const getRefundsById = async (id) => {
  const response = await instance.get(`refunds/get-by-id?id=${id}`);
  return response.data;
};

export const getRefundsByMerchantId = async () => {
  const response = await instance.get(`refunds/get-by-merchant-id`);
  return response.data;
};

export const getRefundsForBranch = async () => {
  const response = await instance.get(`refunds/get-for-branch`);
  return response.data;
};

export const getBranchById = async (id) => {
  const response = await instance.get(`refunds/get-branch-by-id?id=${id}`);
  return response.data;
};
export const getAll = async (from, to, id) => {
  const response = await instance.get('refunds/get-all?from=' + from + '&to=' + to + `${id ? `&boothId=${id}` : ``}`);
  return response.data;
};
export const getRefundSummary = async (from, to, id) => {
  const response = await instance.get(
    'refunds/summary?dateFrom=' + from + '&dateTo=' + to + `${id ? `&boothId=${id}` : ``}`
  );
  return response.data;
};
